import { render, staticRenderFns } from "./ImageSpinner.vue?vue&type=template&id=b906a106&scoped=true"
var script = {}
import style0 from "./ImageSpinner.vue?vue&type=style&index=0&id=b906a106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b906a106",
  null
  
)

export default component.exports